import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import { handleMedia } from "../repository/EdetailingRepository";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import { getBrandData } from "../../ProductCatalogue/hooks/ProductRepository";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";

interface PresentationModalContentProps {
  handleSubmit: (e: React.FormEvent, formData: any) => void;
  handleClose: () => void;
  chechStatusSubmitAndUpdate: string;
  brandData: any;
  presentationTypeData: any;
  languageData: any;
  selectedRow?: any;
  PresentationVersionId?: any;
  setPresentationVersionId: any;
}

const PresentationModalContent: React.FC<PresentationModalContentProps> = ({
  handleSubmit,
  handleClose,
  chechStatusSubmitAndUpdate,
  presentationTypeData,
  languageData,
  selectedRow,
  PresentationVersionId,
}) => {
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const [orgUnit, setOrgUnit] = useState<any>("");
  const [focusBrand, setFocusBrand] = useState<{
    id: number;
    label: string;
  } | null>(null);
  const [formData, setFormData] = useState({
    // orgunit: "",
    BrandId: {},
    // PresentationTypeName: "",
    PresentationName: "",
    PresentationZipUrl: "",
    PresentationVersionId: "1.0",
    PageCount: "1",
    PresentationReleaseDate: "",
    MediaUrl: "",
    // PresentationLanguageId: "",
    PresentationMedia: "",
    PresentationTypeId: "",
  });
  useEffect(() => {
    if (selectedRow) {
      console.log("selectedRow", selectedRow);

      setFormData({
        // orgunit: selectedRow?.orgunit || "",
        BrandId: selectedRow?.brandid
          ? { id: selectedRow.brandid, label: selectedRow.brandName }
          : { id: "", label: "" },
        // PresentationTypeName: selectedRow.PresentationTypeId || "",
        PresentationName: selectedRow.presentationname || "",
        PresentationZipUrl: selectedRow.presentationzipurl || "",
        PresentationVersionId: selectedRow.presentationversionid || "",
        PageCount: selectedRow.PageCount || "",
        PresentationReleaseDate: selectedRow.PresentationReleaseDate || "",
        MediaUrl: selectedRow.mediaurl || "",
        // PresentationLanguageId: selectedRow.PresentationLanguageId || "",
        PresentationMedia: selectedRow.PresentationMedia || "",
        PresentationTypeId: selectedRow.PresentationTypeId || "",
      });

      if (selectedRow.brandid && selectedRow.brandName) {
        setFocusBrand({
          id: Number(selectedRow.brandid),
          label: selectedRow.brandName,
        });
      }
    }
  }, [selectedRow]);
  const handleInputChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        setFormData((prev) => ({ ...prev, PresentationMedia: mediaId }));
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };

  const { data: orgUnitsData } = useGetOrgUnitsData({ enable: true });

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    ([key, value]) => ({
      id: Number(key),
      label: String(value),
    })
  );

  // console.log("FormData:::::::::::::::", formData);

  return (
    <form onSubmit={(e) => handleSubmit(e, formData)}>
      {/* <div className="row-sm-12">
        <ReusableDropdown
          options={formattedOrgUnitData}
          DropdownHeading="Org unit"
          onChange={(selected: any) => {
            setOrgUnit(selected);
            setFormData({ ...formData, orgunit: selected });
            setFocusBrand(null);
          }}
          value={orgUnit || formData?.orgunit || selectedRow?.orgunit}
        />
      </div> */}

      <div className="row mb-3">
        <div className="col-md-12">
          <PaginatedRouteDropdown
            // key={orgUnit}
            placeholder="Select a Brand"
            DropdownHeading="Brand"
            asterisk={true}
            fetchOptions={async (page: any, search: any) => {
              // if (!orgUnit) return [];

              const res = await getBrandData({
                page,
                limit: 10,
                search: search || "",
                Orgunitid: orgUnit,
              });

              return Object.values(res?.data?.data || {}).map((key: any) => ({
                id: key.BrandId,
                label: key.BrandName,
              }));
            }}
            onChange={(val: any) => {
              setFocusBrand(val);

              // ✅ only save ID in formData
              setFormData({ ...formData, BrandId: val });
            }}
            initialSelectedOptions={focusBrand}
          />
        </div>
        {/* <div className="col-md-6">
          <ReusableDropdown
            options={presentationTypeData}
            DropdownHeading="Presentation Type"
            onChange={(selected: any) => {
              setFormData({ ...formData, PresentationTypeName: selected });
            }}
            value={
              formData?.PresentationTypeName || selectedRow?.PresentationTypeId
            }
          />
        </div> */}
      </div>
      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>
            Presentation Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Name"
            name="PresentationName"
            value={formData.PresentationName}
            onChange={handleInputChange}
            style={inputStyle}
          />
        </div>
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>
            Presentation Url <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter URL"
            name="PresentationZipUrl"
            value={formData.PresentationZipUrl}
            onChange={handleInputChange}
            style={inputStyle}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>
            Presentation Version <span style={{ color: "red" }}>*</span>
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter Version"
            name="PresentationVersionId"
            value={PresentationVersionId}
            style={inputStyle}
            disabled
          />
        </div>
        <div className="col-md-6">
          <label className="required-label">
            Page Count <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="PageCount"
            className="form-control"
            placeholder="Enter Page Count"
            value={formData.PageCount}
            disabled
            style={inputStyle}
          />
        </div>
      </div>
      <div className="row mb-3 mt-2">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>
            Media Url <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter URL"
            name="MediaUrl"
            value={formData.MediaUrl}
            onChange={handleInputChange}
            style={inputStyle}
          />
        </div>

        <div className="col-md-6">
          <label className="required-label">
            Presentation Release Date <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="date"
            className="form-control"
            name="PresentationReleaseDate"
            value={formData.PresentationReleaseDate}
            onChange={handleInputChange}
            style={inputStyle}
          />
        </div>
      </div>

      <div className="row mb-3 ">
        {/* <div className="col-md-6">
          <ReusableDropdown
            options={languageData}
            value={
              formData.PresentationLanguageId ||
              selectedRow?.PresentationLanguageId
            }
            onChange={(selected: any) => {
              setFormData({ ...formData, PresentationLanguageId: selected });
            }}
            DropdownHeading="Language"
          />
        </div> */}

        <div className="col-md-6 mt-2">
          <label style={{ fontWeight: "500" }}>Media</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleFileChange}
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>
      {formData.PresentationMedia && (
        <div className="row mb-3">
          <div className="col-md-6" style={{ marginBottom: "10px" }}>
            <label style={{ fontWeight: "500", display: "block" }}>
              Uploaded Media
            </label>

            <img
              src={`${BASE_URL}${formData.PresentationMedia}`}
              alt="Uploaded Media"
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "8px",
                marginTop: "8px",
              }}
            />
          </div>
        </div>
      )}

      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          {chechStatusSubmitAndUpdate === "Submit" ? "Submit" : "Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

// Common input styles
const inputStyle: React.CSSProperties = {
  border: "2px solid #EDEDED",
  borderRadius: "8px",
  padding: "13px",
  fontSize: "14px",
  width: "100%",
};

export default PresentationModalContent;
